function createSchema(schema) {
  return schema;
}

export { createSchema };